import { useCallback, useMemo, useState } from "react";
import { debounce } from "lodash";
import { useSearchCampaignsQuery } from "@/services/campaign-roulette";
import { CampaignType } from "@/@types/campaign-roulette";

export interface LinkedCampaignOption {
  id: number;
  campaignName: string;
  startDate: string;
  endDate: string;
  status: string;
}

export const useLinkedCampaignSearch = () => {
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");

  const debouncedSetQuery = useMemo(
    () => debounce(setDebouncedQuery, 300),
    []
  );

  const onQueryChange = useCallback(
    (value: string) => {
      setQuery(value);
      debouncedSetQuery(value);
    },
    [debouncedSetQuery]
  );

  const { data, isFetching } = useSearchCampaignsQuery(
    { q: debouncedQuery, limit: 10, campaignType: CampaignType.WORLD_CUP },
    { skip: debouncedQuery.trim().length === 0 }
  );

  return {
    query,
    onQueryChange,
    results: data ?? [],
    isLoading: isFetching,
  };
};
